import type { NodeExecution } from 'sprites-types/api/v2/workflows'
import { getToolResultSchema } from 'sprites-types/workflow/tools/common'
import { nativeCsvLlmAction } from 'sprites-types/workflow/tools/nativeCsvLlmAction'
import { MarkdownResult } from '../shared/MarkdownResult'
import { SchemaValidationError } from '../shared/safeParseToolResult'

interface Props {
  nodeExecution: NodeExecution
}

export function NativeCsvLlmActionDisplay({ nodeExecution }: Props) {
  const schema = getToolResultSchema(nativeCsvLlmAction, nodeExecution.inputs)
  const parseResult = schema.safeParse(nodeExecution.outputs)

  if (!parseResult.success) {
    return <SchemaValidationError error={parseResult.error} nodeExecution={nodeExecution} />
  }

  const result = parseResult.data

  return <MarkdownResult data={result} title="CSV LLM Action" />
}
